import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import * as dompurify from 'dompurify';
const DOMPurify = (dompurify as any).default || dompurify;

@Pipe({
  name: 'highlightInitiativeColor',
  standalone: true
})
export class HighlightInitiativeColorPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) {}

  transform(value: any, search: string): SafeHtml {
    if (!value) return this.sanitizer.bypassSecurityTrustHtml('');

    const escapeHtml = (str: string) => String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');

    const stringValue = String(value);
    if (!search) {
      return this.sanitizer.bypassSecurityTrustHtml(escapeHtml(stringValue));
    }

    const i = stringValue.toLowerCase().indexOf(search.toLowerCase());
    if (i === -1) {
      return this.sanitizer.bypassSecurityTrustHtml(escapeHtml(stringValue));
    }

    const before = stringValue.slice(0, i);
    const after = stringValue.slice(i); // from WEB till end

    const escapedBefore = escapeHtml(before);
    const escapedAfter = escapeHtml(after);

    const result = `<span class="text-primary">${escapedBefore}</span><span class="text-danger">${escapedAfter}</span>`;

    const sanitized = DOMPurify.sanitize(result, {
      ALLOWED_TAGS: ['span'],           // span only
      ALLOWED_ATTR: ['class'],          // class attribute only
      FORBID_TAGS: ['script', 'style', 'img', 'a', 'iframe'],
      FORBID_ATTR: ['onclick', 'onerror', 'onload', 'style']
    });

    return this.sanitizer.bypassSecurityTrustHtml(sanitized);
  }
}
